export default __webpack_public_path__ + "static/media/pdalmnt.a8d8c598.webp";